import clsx from 'clsx'

import { Loading } from '../../components/common'
import Navigation from '../../components/Navigation/Navigation'

import styles from './CaseLayout.module.scss'
import useCaseLayout from './useCaseLayout'

interface CaseLayoutProps {
  floatingHeader?: boolean
  alwaysShowNav?: boolean
  children?: React.ReactNode
}

const CaseLayout = (props: CaseLayoutProps) => {
  const { floatingHeader = true, alwaysShowNav, children } = props
  const { loading } = useCaseLayout()

  return (
    <div className={styles.caseLayoutRoot}>
      <Loading loading={loading} message="Loading caseLayout(zone)...">
        <header
          className={clsx(styles.header, floatingHeader && styles.floating)}
        >
          <Navigation alwaysShowNav={alwaysShowNav} />
        </header>
        <main>{children}</main>
        <footer className="closed-eyes">warmer...</footer>
      </Loading>
    </div>
  )
}

export default CaseLayout
